/** @deprecated use `BreakpointName` type from `@noths/polaris-client-ribbons-base` instead of this enum */
export enum Breakpoint {
  L = 'L',
  M = 'M',
  S = 'S',
  XL = 'XL',
  XS = 'XS',
  XXS = 'XXS',
}

export type BreakpointName = keyof typeof Breakpoint;

const XS = 360;
const S = 480;
const M = 768;
const L = 1024;
const XL = 1440;

export const minBreakpoints = { XXS: 0, XS, S, M, L, XL } as const;
export const maxBreakpoints = { XXS: XS - 1, XS: S - 1, S: M - 1, M: L - 1, L: XL - 1 };
